var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('check-login-and-invest',{attrs:{"confirmText":_vm.confirmText}}),_c('check-real-name-and-risk',{attrs:{"showModalInfo":_vm.showModalInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }